import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";
import CategoryList from "../../Components/Cards/CategoryList";
import ProductCard from "../../Components/Cards/Product";
import SortCard from "../../Components/Cards/Sort";
import FlatList from "../../Components/FlatList";
import Loading from "../../Components/Loading";
import SearchBox from "../../Components/SearchBox/SearchListBox";
import { useList } from "./Hooks";

import sliderImg3 from "../../Assets/images/Ad/AdBaner (3)-min.jpg";
import AdSlider from "../Home/components/AdSliders";

const ListProduct = () => {
  const {
    changeObj,
    data,
    loading,
    search,
    getValue,
    clear,
    drawer,
    setDrawer,
    mainData,
    get,
    getForPaginate
  } = useList();

  const [adSrc2, setAdSrc2] = useState([sliderImg3]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3 d-none d-lg-block">
          <CategoryList
            search={search}
            changeObj={changeObj}
            getValue={getValue}
            clear={clear}
          />

        </div>
        <div className="col-lg-9">
          <SearchBox
            getValue={getValue}
            mainData={mainData}
            className="mb-3 mw-100"
            changeObj={changeObj}
            get={get}
          />
          <div className="row">
            <div className="col-12">
              <SortCard
                className="mb-24"
                changeObj={changeObj}
                getValue={getValue}
              />
            </div>
          </div>
          <div className="row">
            {loading
              ?
              <Loading height={"360px"} count={16} col={4} />
              :
              <FlatList
                renderEmpty={() => {
                  return (
                    <div style={{ height: "400px" }}
                      className=" w-100 d-flex justify-content-center align-items-center" >
                      <div>
                        <p>نتیجه‌ای با مشخصات مورد نظر شما پیدا نشد.</p>
                        <div className="d-flex justify-content-center mt-3">
                          <button
                            className="primary-btn-outline"
                            onClick={clear}
                          >
                            حذف فیلتر ها
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }}
                data={data.data}
                renderItem={(item, count) => {
                  return (
                    <div className="col-6 col-lg-4 mb-17 " key={count}>
                      <ProductCard data={item} />
                    </div>
                  );
                }}
              />

            }

            <div className="d-flex align-items-center justify-content-center rounded border shadow-sm p-2">
              {loading || (data && data.data && data.length == 0)
                ? ("")
                :
                <div className="mt-3">
                  {data?.links?.map(item => (
                    <button className={"btn mx-1 " + (item.active ? "btn-primary" : "btn-outline-primary")} onClick={() => getForPaginate(item.url)}>
                      {item.label == "Next &raquo;" && <HiOutlineChevronLeft />}
                      {item.label == "&laquo; Previous" && <HiOutlineChevronRight />}
                      {!["Next &raquo;", "&laquo; Previous"].includes(item.label) && item.label}
                    </button>
                  ))}
                </div>
              }
            </div>
          </div>

          {/* Ad Slider */}
          <div className="row mt-5">
            <div className="col-12">
              <AdSlider srcData={adSrc2} classImg={"doubleSliderbox"} />
            </div>
          </div>

        </div>
      </div>
      <button
        className="filter-btn d-block d-lg-none"
        onClick={() => setDrawer(!drawer)}
      >
        <FaFilter color="#fff" size={"1.3rem"} />
      </button>
      <Offcanvas
        placement="end"
        show={drawer}
        onHide={() => setDrawer(!drawer)}
        className="drawer"
      >
        <CategoryList
          search={search}
          changeObj={changeObj}
          getValue={getValue}
          clear={clear}
        />
      </Offcanvas>
    </div>
  );
};

export default ListProduct;
